import { JSX, useState } from 'react';
import {
    Create,
    useCreate,
    SimpleForm,
    NumberInput,
    SelectInput,
    useNotify,
    useRefresh,
    BooleanInput,
    useRecordContext, TextInput, required, ReferenceInput
} from 'react-admin';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button, LinearProgress
} from '@mui/material';
import {
    Close as CloseIcon,
    Add as AddIcon
} from '@mui/icons-material';
import { Customer } from "../../../../types/entities";
import { currency, frequency } from "../../../../defaults/defaults";
import { useGetCountries } from "../../../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../../../chat-bot/components/ChatFieldBridge";

export const CustomerNewCustomerAddressModal: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const { loading, loadedCountries } = useGetCountries();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [create] = useCreate();
    const notify: any = useNotify();
    const refresh: any = useRefresh();
    const record: Customer = useRecordContext();

    function handleClose(): void {
        setOpenModal(false);
    }

    function handleOpen(): void {
        setOpenModal(true);
    }

    function handleSubmit(values: any): void {
        if (record) {
            values.customer = record.id
            create(
                'customer_addresses',
                {
                    data: values
                },
                {
                    onSuccess: async (data: any): Promise<void> => {
                        refresh();
                        notify(`New address added to ${record?.name}!`, { type: "success" });
                        handleClose();
                    },
                    onError: (error: any): void => {
                        let errorMessage: string;
                        if (typeof error === 'string') {
                            errorMessage = error;
                        } else {
                            errorMessage = error.message;
                        }
                        notify(`Failed to create error: ${errorMessage}`, { type: 'error' });
                    },
                }
            )
        }
    }

    return (
        <>
            <Button variant='contained' onClick={ handleOpen } >
                { "Add New Address " }
                <AddIcon />
            </Button>
            <Dialog
                maxWidth="lg"
                fullWidth
                open={ openModal }
                onClose={ handleClose }>
                <DialogTitle>
                    <div style={ { width: '100%', display: 'flex', justifyContent: 'space-between' } }>
                        <span>{ "Add Customer Address To " + record?.name }</span>
                        <button type="button"
                                onClick={ handleClose }
                                style={ { cursor: 'pointer' } }>
                            <CloseIcon />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Create resource="customer_addresses" title=" ">
                        <SimpleForm onSubmit={ handleSubmit }>
                            <BooleanInput source="defaultAddress" validate={ [required()] } />
                            <TextInput source="lineOne" validate={ [required()] } />
                            <TextInput source="lineTwo"  />
                            <TextInput source="city" validate={ [required()] } />
                            <TextInput source="county"  />
                            <TextInput source="postcode" validate={ [required()] } />
                            { (loading) &&
                                <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                            }
                            { (!loading) &&
                                <SelectInput
                                    name="country"
                                    source="country"
                                    optionValue="id"
                                    choices={ loadedCountries }
                                    validate={ [required()] }
                                />
                            }
                            { /* Offers this modal to the assistant. Renders nothing, writes nothing by
                                 itself. HQ-12: the registry is a stack now, so this no longer displaces
                                 the page form underneath. */ }
                            <ChatFieldBridge />
                        </SimpleForm>
                    </Create>
                </DialogContent>
            </Dialog>
        </>
    );
}